
export class EksternBruger {
        public id: string;
        public navn: string;
        public email: string;
        public erAktiv: boolean;
        public kommendeKonkurrencer: boolean;

        public erGensendt: boolean;
        public isSubmitting: boolean;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EksternBruger.ts